<div *ngIf="showChart">
  <div
    echarts
    *ngIf="!(selectChartLoading$ | async)"
    [options]="echartsOptions"
    (chartInit)="onChartInit($event)"
    class="market-quest-echart"
    id="chart-container{{ randomIdStr }}"
  ></div>
</div>
